type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const FacebookShareActionIcon = (props: Props) => {
  const {
    width = '20',
    height = '20',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M14 4 Q12 2.5 12 5 L12 7 C5 7 1.5 12 1.5 21 C4 17 8 15 12 15 L12 19 Q12 20.5 14 19 L22.5 11.5 Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FacebookShareActionIcon;
